import React from "react";
import {
  FaShoppingCart,
  FaCreditCard,
  FaTrashAlt,
  FaPlus,
  FaMinus,
  FaTrash,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Sidebar from "../dashboard/sidebar";
import useAuth from "../dashboard/useAuth";
import Navbar from "../dashboard/navbar";
import { useCart } from "./CartContext";
import FedaPayButton from './FedaPayButton'; 
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const Panier = (titre) => {
  useAuth();
  const user_id = localStorage.getItem("IDDDD");
  const { cartItems, removeFromCart, updateQuantity, clearCart, subTotal, deliveryCost } = useCart();
  const navigate = useNavigate();

  const handlePaymentSuccess = (transaction) => {
    // Envoyez la confirmation au backend
    axios.post(
      `${process.env.REACT_APP_HOTE}/api/confirm-payment`,
      {
        transaction,
        items: cartItems,
        amount: subTotal + deliveryCost,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(() => {
      clearCart();
      navigate("/payment-success");
    })
    .catch((error) => {
      console.error("Erreur de confirmation:", error);
      navigate("/payment-failed");
    });
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center pt-1">
              <h2 className="mb-0 d-flex align-items-center">
                <FaShoppingCart size={25} className="mr-2" />
                Panier
              </h2>
              <Link to="/produit" className="btn btn-primary btn-lg mt-3">
                Retour
              </Link>
            </div>
          </div>
        </div>

        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-content">
                  <div
                    className="cart-items"
                    style={{ maxHeight: "none", overflowY: "visible" }}
                  >
                    {cartItems.length === 0 ? (
                      <div className="text-center py-5">
                        <img
                          src="/chariot.png"
                          alt="Panier vide"
                          style={{
                            width: "100px",
                            opacity: 0.6,
                            marginBottom: "15px",
                          }}
                        />
                        <p style={{ fontSize: "1rem" }}>
                          Votre panier est vide
                        </p>
                        <Link to="/produit" className="btn btn-primary mt-2">
                          Voir les produits
                        </Link>
                      </div>
                    ) : (
                      <>
                        {cartItems.map((item) => (
                          <div
                            key={item.id}
                            className="d-flex align-items-center mb-3 p-3"
                            style={{
                              borderBottom: "1px solid #f0f0f0",
                              backgroundColor: "#fff",
                              borderRadius: "8px",
                            }}
                          >
                            <div
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: "8px",
                                overflow: "hidden",
                                marginRight: "15px",
                              }}
                            >
                              <img
                                src={
                                  item.photo_url ||
                                  "/static/images/default-product.png"
                                }
                                alt={item.nom}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            <div style={{ flex: 1 }}>
                              <div className="d-flex justify-content-between">
                                <h6
                                  style={{
                                    fontWeight: 600,
                                    marginBottom: "5px",
                                  }}
                                >
                                  {item.nom}
                                </h6>
                                <h6
                                  style={{ fontWeight: 600, color: "#1ab394" }}
                                >
                                  {item.prix * item.quantity} CFA
                                </h6>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <button
                                    onClick={() =>
                                      updateQuantity(item.id, item.quantity - 1)
                                    }
                                    className="btn btn-sm btn-outline-secondary"
                                    style={{ width: "30px" }}
                                    disabled={item.quantity <= 1}
                                  >
                                    <FaMinus />
                                  </button>
                                  <span
                                    className="mx-0"
                                    style={{
                                      minWidth: "30px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.quantity}
                                  </span>
                                  <button
                                    onClick={() =>
                                      updateQuantity(item.id, item.quantity + 1)
                                    }
                                    className="btn btn-sm btn-outline-secondary"
                                    style={{ width: "30px" }}
                                  >
                                    <FaPlus />
                                  </button>
                                </div>

                                <button
                                  onClick={() => removeFromCart(item.id)}
                                  className="btn btn-sm btn-outline-danger"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}

                        <div
                          className="cart-summary mt-3 p-2"
                          style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "5px",
                          }}
                        >
                          <div className="d-flex justify-content-between mb-1">
                            <small>Sous-total:</small>
                            <small className="fw-bold">{subTotal} CFA</small>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <small>Nombre de produit:</small>
                            <small className="fw-bold">
                              {cartItems.length}
                            </small>
                          </div>
                          <div
                            className="d-flex justify-content-between fw-bold pt-2"
                            style={{ borderTop: "1px solid #ddd" }}
                          >
                            <span>Total:</span>
                            <span style={{ color: "#1ab394" }}>
                              {subTotal + deliveryCost} CFA
                            </span>
                          </div>

                          <div className="d-grid gap-2 mt-3">
                            <FedaPayButton
                              onSuccess={handlePaymentSuccess}
                              className="btn btn-success btn-sm py-1 mr-4"
                            />

                            <button
                              className="btn btn-danger btn-sm py-1"
                              onClick={clearCart}
                            >
                              <FaTrashAlt className="me-1" /> Vider
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Panier;
